import httpStatus from "http-status-codes";

export default class ResourceService {

    $api;
    $sessionService;

    constructor(api, sessionService) {
        this.$api = api;
        this.$sessionService = sessionService;
    }

    get headers() {
        return {
            Authorization: `Bearer ${this.$sessionService.get()}`
        };
    }

    setAccess(resource, type_id, application, access) {
        return this.$api.put(
            `/resources/${resource}/${application}/access`,
            {
                access: access,
                type_id: type_id,
            },
            {headers: this.headers}
        ).then(
            () => {
                Promise.resolve(true)
            }
        ).catch((error) => {
            throw error
        });
    }

    addResource(resource) {
        return this.$api.post(
            "/resources/create",
            resource,
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.CREATED
            }
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    getAccess() {
        return this.$api.get(
            "/resources/access",
            {headers: this.headers})
            .then(response => response.data)
            .catch(() => Promise.reject())
    }

    getApplications() {
        return this.$api.get("/resources/applications",
            {headers: this.headers})
            .then(response => response.data)
            .catch(() => Promise.reject())
    }

    getResources() {
        return this.$api.get("/resources",
            {headers: this.headers})
            .then(response => response.data)
            .catch(() => Promise.reject())
    }

    getResourceTypes() {
        return this.$api.get("/resources/types",
            {headers: this.headers})
            .then(response => response.data)
            .catch(() => Promise.reject())
    }
}
